//@ts-nocheck
import { store } from "@/store/index";
import { Button, Modal, message } from "antd";
import axios from "axios";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { log } from "console";
const { confirm } = Modal;
// 传入参数
// @initVideoFn
class CCvideoControlClass {
  public count: number = this.getNumber();
  private ccVideoUrl = `https://yth.mvwchina.com/cc/videourl`; // cc的video接口
  private API_KEY = "Y7gxBFDbz5yBU36vDXCv0RbIjyykV5Dt";
  private userId = "D71B0368E20B4CF5"; // 用户id
  // 获取当前随机次数
  getNumber(): number {
    const { videoStatus } = store.getState();
    const { randomPopUpNum = 1 } = videoStatus;
    return randomPopUpNum;
  }
  // 全局计时器
  start(video: any, position: any, time: any, videoStatus: any) {
    const { onHookTipInfo } = videoStatus;
    console.log(window.pauseTimer, this.count);
    if (window.pauseTimer === null && this.count > 0) {
      this.count--;
      // 随机数
      let restTime = time - parseInt(position);
      let randonNum = Math.floor(Math.random() * (restTime - 0) + 0);
      window.pauseTimer = setInterval(() => {
        console.log("多少秒之后暂停弹窗", randonNum);
        console.log("剩余弹出次数", this.count);
        if (randonNum <= 0) {
          video.pause(); // 暂停视频
          this.pause(); // 清除计时器
          setTimeout(() => {
            alert(onHookTipInfo);
          }, 800);
        } else {
          randonNum--;
        }
      }, 1000);
    }
  }
  // 暂停视频
  pause() {
    clearInterval(window.pauseTimer);
    window.pauseTimer = null;
  }
  // 重置视频
  reset() {
    // 设置弹出次数
    this.count = this.getNumber();
  }
  /**
   * 记录视频进度
   * @param watchEventType 1:点击播放按钮;2:听课计时;3:听课结束(播放器当前位置到视频时长最大值）
   * @returns
   */
  async watch(watchEventType: number) {
    const { videoStatus } = store.getState();
    const {
      preventOnHookType,
      courseId,
      sectionId,
      watchStartTime = 0,
      videoDuration, // 总时长
    } = videoStatus;
    if (!window.ccPlayerStatus) return;
    let video = window.ccPlayerStatus;
    let position = parseInt(
      window.ccPlayerStatus.getPosition() || watchStartTime
    ); // 获取视频进度
    // 调用随机弹窗的方法
    if (preventOnHookType === 2) {
      this.start(video, position, videoDuration, videoStatus);
    }
    let param = {
      itemId: sectionId,
      sectionId: courseId,
      videoDuration,
      watchAt: position,
      watchEventType,
    };
    // 如果是看到最后，跳过一次请求
    if (watchEventType === 2 && position === video.getDuration()) {
      return;
    }
    if (watchEventType === 3) {
      // 如果是视频结束状态
      Object.assign(param, { totalWatchTime: position - watchStartTime });
    }
    const { data } = await axios.post("/shop/front/item/record/update", param);
    // 如果是当前视频或者是需要付费，重载页面调用play页面的验证人脸方法或者支付方法
    if (data.data === "notCurrentWatchVideo" || data.code == 100005) {
      // 如果是多开的情况，强制暂停视频
      this.preventOpenMoreVideoFn(video);
      // 需要购买
      if (data.code === 100005) {
        window.location.reload();
      }
    }
  }
  // 防多开
  async preventOpenMoreVideoFn(video: any) {
    video.pause();
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: <p>您有其他正在播放的视频，本视频已暂停播放。</p>,
      onOk() {
        Modal.destroyAll();
      },
      onCancel() {
        Modal.destroyAll();
      },
    });
  }
  // 初始化视频功能
  async initVideo() {
    window.pauseTimer = null;
    window.onCCH5PlayerLoaded = () => {
      window.ccH5PlayerJsLoaded = true;
    };
    window.on_player_volumechange = (volume: any, vid: any) => {
      console.log("设置音量回调:  ", volume, vid);
    };
    // 播放器初始化完成
    window.on_CCH5player_ready = async (video: any) => {
      const { videoStatus } = store.getState();
      const { courseId, preventMoreOpenDialogFlag = 0 } = videoStatus;
      const { data } = await this.getPlayingVideoFlag();
      if (data === courseId || data === 0 || preventMoreOpenDialogFlag === 0) {
      } else {
        confirm({
          icon: <ExclamationCircleOutlined />,
          content: (
            <p>
              您已经打开了一个视频，是否播放本视频，打开本视频将关闭已打开视频
            </p>
          ),
          onOk() {
            Modal.destroyAll();
          },
          onCancel() {
            Modal.destroyAll();
          },
        });
      }
    };
    /**CC视频开始播放
     * @param {video}视频信息
     * @param {vid} vid
     * @return {void}
     */
    window.on_CCH5player_play = async (video: any, vid: any) => {
      video.play();
      console.log("----play----");
      this.watch(1);
      clearInterval(window["playing"] as any);
      // 每30秒调用一次接口
      (window["playing"] as any) = setInterval(() => {
        this.watch(2);
      }, 30000);
    };
    /**CC视频暂停
     * @param {any}
     * @param {vid} vid
     * @return {void}
     */
    window.on_CCH5player_pause = (video: any, vid: string) => {
      console.log("----暂停----");
      this.watch(3);
      this.pause();
      // 清空30秒上传数据接口
      clearInterval(window["playing"]);
    };
    /**CC播放结束
     * @param {any}
     * @param {vid} vid
     * @return {void}
     */
    window.on_CCH5player_ended = (video: any, vid: string) => {
      console.log("----结束----");
      // 清空随机数计时器
      this.watch(3);
      this.pause();
      // 清空30秒上传数据接口
      clearInterval(window["playing"]);
    };
    /**
     *
     * @param mode 是否全屏 0为退出全屏 1为变成全屏
     * @param vid
     */
    // window.on_player_fullscreen = async (mode: 0 | 1, vid: string) => {
    //   if (mode === 1) {
    //     const ccVideoUrl = await videoControlInstance.getCCVideoUrlById(vid);
    //     await videoControlInstance.openVideo(ccVideoUrl as string);
    //   }
    // };
  }
  /**
   * 判断当前视频是否是播放状态
   */
  async getPlayingVideoFlag() {
    /**0:没有正在播放的视频 1:有正在播放的视频 */
    const { data } = await await axios.post(
      `/shop/front/ce/user/current/watch/section/info`
    );
    return data;
  }
}
export class AliVideControlClass {
  public count: number = 0;
  public player = null as any;
  // 记录视频进度
  async watch(watchEventType: number) {
    const { videoStatus } = store.getState();
    const {
      preventOnHookType,
      courseId,
      sectionId,
      watchStartTime = 0,
      videoDuration, // 总时长
    } = videoStatus;
    let video = this.player;
    let position = parseInt(this.player.getCurrentTime() || watchStartTime); // 获取视频进度
    // 调用随机弹窗的方法
    if (preventOnHookType === 2) {
      this.start(video, position, videoDuration, videoStatus);
    }
    let param = {
      itemId: sectionId,
      sectionId: courseId,
      videoDuration,
      watchAt: position,
      watchEventType,
    };
    // 如果是看到最后，跳过一次请求
    if (watchEventType === 2 && position === video.getDuration()) {
      return;
    }
    if (watchEventType === 3) {
      // 如果是视频结束状态
      Object.assign(param, { totalWatchTime: position - watchStartTime });
    }
    const { data } = await axios.post("/shop/front/item/record/update", param);
    // 如果是当前视频或者是需要付费，重载页面调用play页面的验证人脸方法或者支付方法
    if (data.data === "notCurrentWatchVideo" || data.code == 100005) {
      // 如果是多开的情况，强制暂停视频
      this.preventOpenMoreVideoFn(video);
      if (data.code === 100005) {
        // message.info("试听已结束，请进行购买");
        window.location.reload();
      }
    }
  }
  // 防多开
  async preventOpenMoreVideoFn(video: any) {
    video.pause();
  }
  // 全局计时器
  start(video: any, position: any, time: any, videoStatus: any) {
    const {
      onHookTipInfo,
      videoUniqueCode,
      projectId,
      topicId,
      courseId,
      sectionId,
    } = videoStatus;
    console.log(window.aliPauseTimer, this.count);
    if (window.aliPauseTimer === null && this.count > 0) {
      // 随机数
      let restTime = time - parseInt(position);
      let randonNum = Math.floor(Math.random() * (restTime - 0) + 0);
      window.aliPauseTimer = setInterval(() => {
        console.log("多少秒之后暂停弹窗", randonNum);
        console.log("剩余弹出次数", this.count);
        if (randonNum <= 0) {
          video.pause(); // 暂停视频
          this.pause(); // 清除计时器
          setTimeout(() => {
            let popupUniqueCode = new Date().getTime() + "";
            axios.post("/shop/front/addUserWatchPopupLog", {
              projectId,
              topicId,
              courseId,
              sectionId,
              videoUniqueCode,
              popupUniqueCode,
              popupType: 1,
            });
            alert(onHookTipInfo);
            this.count--;
            axios.post("/shop/front/addUserWatchPopupLog", {
              projectId,
              topicId,
              courseId,
              sectionId,
              videoUniqueCode,
              popupUniqueCode,
              popupType: 2,
            });
          }, 800);
        } else {
          randonNum--;
        }
      }, 1000);
    }
  }
  // 暂停视频
  pause() {
    clearInterval(window.aliPauseTimer);
    window.aliPauseTimer = null;
  }
  initAliPlayer(player: any) {
    window.aliPauseTimer = null;
    this.player = player;
    const { videoStatus } = store.getState();
    const { progressbar_enable, rate_allow_change, randomPopUpNum } =
      videoStatus;

    // 设置随机弹出数量
    this.count = randomPopUpNum;
    /**
     * 阿里云视频准备完毕
     */
    player.on("ready", () => {
      // 实现进度条是否能拖拽
      this.preventSeeking(progressbar_enable);
      // 设置是否允许倍速
      this.seetSpeed(rate_allow_change);
    });
    /**
     * 首次播放
     */
    player.on("play", () => {
      console.log("首次播放");
      clearInterval(window["aliPlaying"] as any);
      this.watch(1);
      // 每30秒调用一次接口
      (window["aliPlaying"] as any) = setInterval(() => {
        this.watch(2);
      }, 30000);
    });
    /**
     * 视频暂停
     */
    player.on("pause", () => {
      console.log("----暂停----");
      this.watch(2);
      this.pause();
      // 清空30秒上传数据接口
      clearInterval(window["aliPlaying"]);
    });
    /**
     * 视频播放结束
     */
    player.on("ended", () => {
      console.log("----结束----");
      // 清空随机数计时器
      this.watch(3);
      this.pause();
      // 清空30秒上传数据接口
      clearInterval(window["aliPlaying"]);
    });
    player.on("showBar", () => {});
  }
  preventSeeking(progressbar_enable: number) {
    if (progressbar_enable === 0) {
      (
        document.getElementsByClassName("prism-progress")[0] &&
        (document.getElementsByClassName("prism-progress")[0] as HTMLElement)
      ).style["pointer-events"] = "none";
    }
  }
  seetSpeed(rate_allow_change: number) {
    if (rate_allow_change === 0) {
      // @ts-ignore
      (
        document.getElementsByClassName("prism-setting-speed")[0] &&
        (document.getElementsByClassName(
          "prism-setting-speed"
        )[0] as HTMLElement)
      ).style["display"] = "none";
    }
  }
}
export let CCvideoControlInstance = new CCvideoControlClass();
export let AlivideoControlInstance = new AliVideControlClass();
